import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const toastOptions = {
  position: "bottom-left",
  autoClose: 3000, // Auto-close after 3 seconds
  hideProgressBar: true,
  closeOnClick: true,
  pauseOnHover: false,
  draggable: true,
  progress: undefined,
  theme: "light",
};

const toastService = {
  message: (message) => {
    toast(message, { ...toastOptions, style: { fontSize: "20px" } });
  },
  success: (message) => {
    toast.success(message, toastOptions);
  },
  error: (message) => {
    toast.error(message, toastOptions);
  },
  info: (message) => {
    toast.info(message, toastOptions);
  },
  warning: (message) => {
    toast.warning(message, toastOptions);
  },
};

export default toastService;
